import type { ProductAvailabilityMode } from '../types';

export type { ProductAvailabilityMode };

/** Soft pending hold on rental_requests.reservation_expires_at (DB trigger). */
export const PENDING_RESERVATION_TTL_MINUTES = 30;

export const PRODUCT_AVAILABILITY_MODES: ProductAvailabilityMode[] = [
  'request_first',
  'capacity',
  'strict',
];

export const AVAILABILITY_MODE_LABELS: Record<ProductAvailabilityMode, string> = {
  request_first: 'Förfrågan först (rekommenderas)',
  capacity: 'Visa kapacitetstryck',
  strict: 'Visa hög beläggning i kalender',
};

export const AVAILABILITY_MODE_DESCRIPTIONS: Record<ProductAvailabilityMode, string> = {
  request_first:
    'Kunden kan alltid skicka förfrågan. Kalender och eget lager är vägledande – shortage blockerar aldrig bokning.',
  capacity:
    'Visar kapacitetstryck när efterfrågan närmar sig eller överstiger eget lager. Blockerar aldrig bokning p.g.a. shortage.',
  strict:
    'Visualiserar hög beläggning tydligare i kalendern. Blockerar aldrig bokning p.g.a. shortage. Manuella blocked_dates gäller fortfarande.',
};

export function normalizeAvailabilityMode(
  value: string | null | undefined
): ProductAvailabilityMode {
  if (value === 'capacity' || value === 'strict') return value;
  return 'request_first';
}

/**
 * Inventory Architecture v2: shortage / owned capacity must NEVER hard-block checkout.
 * Manual product blocked_dates are enforced separately (calendar), not via this helper.
 */
export function blocksBookingSubmission(
  _mode: ProductAvailabilityMode | null | undefined,
  _available: boolean
): boolean {
  return false;
}

/**
 * Do not lock calendar dates solely because inventory/capacity looks full.
 * Manual blocked_dates remain handled separately by the calendar.
 */
export function locksOccupiedDatesInCalendar(
  _mode: ProductAvailabilityMode | null | undefined
): boolean {
  return false;
}

/** Customer-facing copy when own stock looks insufficient — never "Ej tillgänglig". */
export function inventoryCoveragePressureMessage(): string {
  return (
    'Eget lager räcker kanske inte för valda datum. Du kan ändå skicka en förfrågan – ' +
    'vi bedömer leverans med egen utrustning, omfördelning, inköp eller stödhyra.'
  );
}
